import sanitizeHtml from 'sanitize-html';

export default {
  methods: {
    sanitizeContent: sanitizeHtml,
  },
};
